import { render, staticRenderFns } from "./Jogador.vue?vue&type=template&id=35275ef6&scoped=true&"
import script from "./Jogador.vue?vue&type=script&lang=js&"
export * from "./Jogador.vue?vue&type=script&lang=js&"
import style0 from "./Jogador.vue?vue&type=style&index=0&id=35275ef6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35275ef6",
  null
  
)

export default component.exports